import ListView from "./list-view";
import TableView from "./table-view";
import B2CTableView from "./b2c-table-view"

interface ComponentProps {
  selectedView: string;
}

export default function ClientsContent(props: ComponentProps) {
  const { selectedView } = props;
  return (
    <div className="clients-contentss">
      {selectedView === "B2B clients" ? <TableView /> : <B2CTableView />}
    </div>
  );
}
